const ecommerceGallery = [
    {
        id: 1,
        type: 'image',
        src: `${process.env.PUBLIC_URL}/img/ecommerce/levis-engineered-jeans.png`,
        title: "Levi's Engineered Jeans",
        brand: "Levi's MX",
        year: '2019',
        stack: ['HTML5', 'SCSS', 'JavaScript', 'Shopify'],
        datasets: ['dev', 'ops'],
    },
    {
        id: 2,
        type: 'image',
        src: `${process.env.PUBLIC_URL}/img/ecommerce/levis-earth-day-campaign.png`,
        title: "Levi's Earth Day Campaign",
        brand: "Levi's MX",
        year: '2019',
        stack: ['HTML5', 'Responsive Design', 'SCSS'],
        datasets: ['dev', 'ops'],
    },
    {
        id: 3,
        type: 'image',
        src: `${process.env.PUBLIC_URL}/img/ecommerce/levis-hailey-bieber-campaign.png`,
        title: "Levi's Hailey Bieber Campaign",
        brand: "Levi's MX",
        year: '2019',
        stack: ['HTML5', 'JavaScript', 'Campaign Landing'],
        datasets: ['dev', 'ops'],
    },
    {
        id: 4,
        type: 'image',
        src: `${process.env.PUBLIC_URL}/img/ecommerce/levis-justin-timberlake.png`,
        title: "Levi's x Justin Timberlake",
        brand: "Levi's MX",
        year: '2019',
        stack: ['SCSS', 'Frontend', 'Responsive UI'],
        datasets: ['dev', 'ops'],
    },
    {
        id: 6,
        type: 'image',
        src: `${process.env.PUBLIC_URL}/img/ecommerce/calvin-klein-fragrances.png`,
        title: 'Calvin Klein Fragrances',
        brand: 'Calvin Klein MX',
        year: '2019',
        stack: ['Campaign Landing', 'CSS3', 'JavaScript'],
        datasets: ['dev', 'ops'],
    },
    {
        id: 9,
        type: 'image',
        src: `${process.env.PUBLIC_URL}/img/ecommerce/coach-homepage.png`,
        title: 'Coach Homepage',
        brand: 'Coach MX',
        year: '2019',
        stack: ['Responsive Design', 'SCSS', 'Frontend'],
        datasets: ['dev', 'ops'],
    },
    {
        id: 10,
        type: 'image',
        src: `${process.env.PUBLIC_URL}/img/ecommerce/rapsodia-homepage.png`,
        title: 'Rapsodia Homepage',
        brand: 'Rapsodia MX',
        year: '2019',
        stack: ['HTML5', 'Fashion Ecommerce', 'SCSS'],
        datasets: ['dev', 'ops'],
    },
    {
        id: 11,
        type: 'image',
        src: `${process.env.PUBLIC_URL}/img/ecommerce/rapsodia-campaign.png`,
        title: 'Rapsodia Campaign Landing',
        brand: 'Rapsodia MX',
        year: '2019',
        stack: ['Landing Page', 'Responsive UI', 'CSS3'],
        datasets: ['dev', 'ops'],
    },
    {
        id: 12,
        type: 'image',
        src: `${process.env.PUBLIC_URL}/img/ecommerce/mobile-ecommerce-ui.png`,
        title: 'Mobile Ecommerce UI',
        brand: 'Mobile Commerce',
        year: '2020',
        stack: ['Mobile First', 'UI Design', 'Responsive'],
        datasets: ['dev', 'ops'],
    },
    {
        id: 13,
        type: 'image',
        src: `${process.env.PUBLIC_URL}/img/ecommerce/osom-counter-component.png`,
        title: 'OSOM Counter Component',
        brand: 'OSOM',
        year: '2020',
        stack: ['React', 'Frontend Component', 'JavaScript'],
        datasets: ['dev', 'ops'],
    },
];

export function getEcommerceGalleryByDataset(datasetId) {
    return ecommerceGallery.filter((item) =>
        !item.datasets || item.datasets.includes(datasetId)
    );
}

export default ecommerceGallery;
